


































import {Component, Mixins, Prop, Ref, Vue} from 'vue-property-decorator';
import JdhLogicalCheckbox from "@/design-system/forms/fields/JdhLogicalCheckbox.vue"
import UniqueIdMixin from "@/design-system/utilities/UniqueIdMixin"
import JdhHeightTransition from "@/design-system/shared/JdhHeightTransition.vue"
import JdhErrorMessage from "@/design-system/forms/fields/JdhErrorMessage.vue"
import JdhValidationProvider from "@/design-system/forms/fields/JdhValidationProvider.vue"
import JdhFieldStructure from "@/design-system/forms/shared/JdhFieldStructure.vue"
import JdhInputArea from "@/design-system/forms/shared/JdhInputArea.vue"
import JdhAttachedModalPopup from "@/design-system/shared/JdhAttachedModalPopup.vue"
import JdhLogicalColorPicker
    from "@/design-system/forms/fields/ColorPicker/JdhLogicalColorPicker.vue"
import {colord} from "colord"

/**
 * @status stable
 * @published $next
 * @changelog $next Published.
 *
 * TODO: we should allow for a larger-than-anchor mode for AttachedModalPopup; it's okay for
 * color pickers to be wider than the input (in fact, it's the norm).
 */
@Component({
    components: {
        JdhLogicalColorPicker,
        JdhAttachedModalPopup,
        JdhInputArea,
        JdhFieldStructure,
        JdhValidationProvider, JdhErrorMessage, JdhHeightTransition, JdhLogicalCheckbox}
})
export default class JdsColorPicker extends Mixins(UniqueIdMixin) {
    @Prop() value!: string
    @Prop() label!: string
    @Prop({type: Boolean, default: false}) required!: boolean
    @Prop() width!: number

    @Ref() inputEl!: HTMLElement

    open = false
    focused = false

    get rules() {
        return {}
    }

    toggleDropdown() {
        this.open = !this.open
    }

    get currentColor () {
        if (!this.value) return '-'
        return colord(this.value).toHex()
    }
}
